import { render, staticRenderFns } from "./c-control-panel-notification-profile.vue?vue&type=template&id=c931a956&"
import script from "./c-control-panel-notification-profile.vue?vue&type=script&lang=js&"
export * from "./c-control-panel-notification-profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports